import React from "react";
import Homepage from "../../component/homepage";
export function Homepages() {
  return <Homepage />;
}
